import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BreadcrumbHeading from '../../components/global/BreadcrumbHeading';
import { Table, message, Modal, Input, Button } from 'antd';
import InputField from '../../components/global/InputField';
import { Combobox } from 'react-widgets';
import CelaneseAPI from '../../services';
import config, { utils } from '../../config';
import { getCompaniesData } from '../../actions/index';
import './RequestAccess.css';
import Translation from '../../Translation';
const stringSort = (a, b) => {
    if (a < b) { return -1; }
    if (a > b) { return 1; }
    return 0;
}
const dateSort = (a, b) => {
    if (new Date(a).getTime() < new Date(b).getTime()) { return -1; }
    if (new Date(a).getTime() > new Date(b).getTime()) { return 1; }
    return 0;
}
// const guid = () => {
//     function s4() {
//         return Math.floor((1 + Math.random()) * 0x10000)
//             .toString(16)
//             .substring(1);
//     }
//     return s4() + s4() + s4() + s4() + s4() + s4() + (new Date).getTime().toString(16);
// }
/**
 * Class for ManageUsers.
 *
 * @class ManageUsers
 * @extends {React.Component}
 */
class RequestAccess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            
            rows: [],
            apiData: [],
            messagesList: [],

            sortedInfo: {
                columnKey: 'createdAt',
                order: 'descend'
            },
            filteredInfo: {},
            userList: [],

            visibleNewUserModal: false,
            isCreateLoading: false,
            errorMessage: '',
            userRole: 'user',
            emailAddress: '',
            firstName: '',
            lastName: '',
            userCountry: '',
            userCompany: '',
            userFunction: '',
            userPhoneNumber: '',
            custCompany: '',

            countryNames: [],
            filteredCountryNames: [],
            isDuplicateInTowplus: false,
            userCompanyError: false
        }
    }

    /**
     * filterDropdown function is for showing dropdown for each column in the tow items table.
     *
     * @param {Object} opts which is object, it will take selected row keys and user confirmation.
     * @memberof TranslationTable
     */
    filterDropdown = (opts) => {
        let that = this;
        return (
            <div className="custom-filter-dropdown">
                <Input
                    ref={ele => that.searchInput = ele}
                    placeholder={utils.getTranslationText('lbl_filter_text', 'Filter text or =,<,>,=>,<=')}
                    value={opts.selectedKeys ? opts.selectedKeys[0] : '' }
                    onChange={e => opts.setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={that.handleSearch(opts.selectedKeys, opts.confirm)}
                />
                <Button type="primary" onClick={that.handleSearch(opts.selectedKeys, opts.confirm)}><Translation labelName="lbl_search" defaultText="Search" /></Button>
                <Button onClick={that.handleReset(opts.clearFilters)}><Translation labelName="lbl_reset" defaultText="Reset" /></Button>
            </div>)
    }
    /**
    * onFilterDropdownVisibleChange function is for toggling the search input visibility.
    * 
    * @param {boolean} visible takes boolean as input
    * @memberof TranslationTable
    */
    onFilterDropdownVisibleChange = (visible) => {
        let that = this;
        if (visible) {
            setTimeout(() => {
                that.searchInput.focus();
            });
        }
    }
    /**
     * tableRender function is for rendering of highlighted text.
     * 
     * @param {string} text which will take string as input
     * @memberof TranslationTable
     */
    tableRender = (text) => {
        const { searchText } = this.state;
        return searchText ? (
            <span>
                {text.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map((fragment, i) => (
                    fragment.toLowerCase() === searchText.toLowerCase()
                        ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
                ))}
            </span>
        ) : text;
    }
    /**
     * handleSearch function is for performing search on the table with selected row keys.
     * @param {array} selectedKeys
     * @param {func} confirmhandler
     * @memberof TranslationTable
     */
     handleSearch = (selectedKeys, confirmhandler) => () => {
        confirmhandler();
        this.setState({ searchText: selectedKeys[0] });
    }

    /**
     * handleReset function is for clearing searched fields on the table.
     * @param {func} clearFilters
     * @memberof TranslationTable
     */
    handleReset = clearFilters => () => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    componentWillMount() {
        this.setState({
            loading: true
        });
        getCompaniesData().then((res) => {
            this.setState({
                apiData: res && res.data ? res.data : []
            });
        }).catch(() => { });
        this.getCountryNames();
        this.getMessagesList();
    }
    getCountryNames = (e) => {
        CelaneseAPI.get(config.API.countryNames).then(resp => {
            if (resp && resp.data) {
                this.setState({
                    countryNames: resp.data,
                    filteredCountryNames: resp.data
                });
            }
        });
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.companiesData) {
            this.setState({
                apiData: nextProps.companiesData
            });
        }
    }

    /**
     * success function shows a success message when message is created successfully
     * @param {string} msg custom message to be shown
     * @memberof ManageUsers
     */
    success = (msg) => {
        message.success(msg, 2);
    }

    /**
     * error function shows a error message
     * @memberof ManageUsers
     */
    error = () => {
        message.error(utils.getTranslationText('msg_some_issue', 'There was some issue.'), 2);
    }

    cancelAction = () => {
    }

 
    /**
     * getMessagesList function is for getting list of all messages which are entered by the admin
     * @memberof ManageUsers
     */
    getMessagesList = () => {
        this.setState({
            loading: true
        });
        CelaneseAPI.get(config.API.manageUsers).then(resp => {
            this.setState({
                userList: resp && resp.data ? resp.data : []
            });
        });
        CelaneseAPI.get(config.API.getRequestAccess).then(resp => {
            this.setState({
                messagesList: resp && resp.data ? resp.data : [],
                loading: false,
                rows: resp && resp.data ? resp.data : []
            });
        });
    }
    
    handleChange = (e) => {
        if (e && e.target) {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }


    clearFilters = (e) => {
        e.preventDefault();
        this.setState({
            sortedInfo: {
                columnKey: 'lastLogin',
                order: 'descend'
            },
            filteredInfo: {}
        });
    }

    onTableChange = (a, b, c) => {
        this.setState({
            sortedInfo: c,
            filteredInfo: b
        });
    }

    showAddCompanyModal = (e, rec) => {
        e && e.preventDefault();
        this.setState({
            visibleNewUserModal: true,
            emailAddress: rec.email,
            firstName: rec.firstName,
            lastName: rec.lastName,
            userCountry: rec.country,
            userCompany: '',
            userFunction: rec.function,
            userPhoneNumber: rec.phone,
            custCompany: rec.company,
            userCompanyError: false,
            errorMessage: false
        });
    }
    closeNewUserModal = () => {
        this.setState({
            visibleNewUserModal: false,
        });
    }
    isCreateUserFormValid = (userRole) => {
        let inValidCount = 0;
        if(this.state.emailAddress.trim().length === 0) {
            inValidCount += 1;
        }
        if(this.state.firstName.trim().length === 0) {
            inValidCount += 1;
        }
        if(this.state.lastName.trim().length === 0) {
            inValidCount += 1;
        }
        if(this.state.userCompany.trim().length === 0) {
            inValidCount += 1;
            this.setState({
                userCompanyError: true
            });
        }
        if(inValidCount > 0) {
            this.setState({
                errorMessage: 'Please fill the required fields'
            });
            return false;
        }
        return true;
    }
    sendEmailInvitation = (formData) => {
        if (formData['role'] && (formData['role'].toUpperCase() === 'user'.toUpperCase())) {
            CelaneseAPI.post(config.API.sendInvitation, {
                "to": formData['emailAddress'],
                "firstname": formData['firstName'],
                "lastname": formData['lastName'],
                "loginUrl": window.location.origin,
                "password": formData['password']
            }).then(resp => {
                if (resp.data && resp.data.message) {
                    message.warning(
                        utils.getTranslationText(
                            'msg_user_send_invite_error',
                            'User created successfully, but the invitation email could not be sent.'
                        ),
                        2
                    );
                } else {
                    message.success(
                        utils.getTranslationText(
                            'msg_user_created_success',
                            'User created successfully.'
                        ),
                        2
                    );
                }
            });
        }
    }
    updateUserCompany = (e) => {
        this.setState({
            userCompany: e.target.value,
            userCompanyError: false
        });
    }
    createNewUser = () => {
        if (this.state.userRole === 'user' && this.isCreateUserFormValid('user')) {
            this.setState({
                isCreateLoading: true
            });
            let formData = {
                "emailAddress": this.state.emailAddress,
                "firstName": this.state.firstName,
                "lastName": this.state.lastName,
                "password": this.state.password || "",
                "role": this.state.userRole,
                "company": this.state.userCompany,
                "custCompany": this.state.custCompany,
                "country": this.state.userCountry,
                "forceChangePasswordNextSignIn": true,
                "function": this.state.userFunction,
                "phone": this.state.userPhoneNumber
            };
           
            if (this.state.isDuplicateInTowplus) {
                formData['isDuplicateInTowplus'] = true;
            }
            CelaneseAPI.post(config.API.manageUsers, formData).then((resp) => {
                let isDuplicateInTowplus = false;
                if (resp.error) {
                    let errorToShow = 'Unable to create user, please check your fields';
                    if (resp.error.code) {
                        if (resp.error.code === 'USER_ALREADY_EXISTS') {
                            errorToShow = 'User already exists in Towplus application';
                            isDuplicateInTowplus = true;
                        }
                    }
                    if (resp.error.message) {
                        errorToShow = resp.error.message;
                        if (resp.error.message.indexOf('userPrincipalName already exists') >= 0) {
                            errorToShow = 'User already exists in Azure portal';
                        }
                    }
                    this.setState({
                        isCreateLoading: false,
                        errorMessage: errorToShow,
                        isDuplicateInTowplus
                    });
                } else {
                    this.setState({
                        isCreateLoading: false,
                        visibleNewUserModal: false
                    });
                    this.getMessagesList();
                    this.sendEmailInvitation(formData);
                }
            });
        }
    };

    render() {
        let { filteredInfo, userList } = this.state;
        let userMap = {};
        for(let i = 0, len = userList.length; i < len; i++) {
            let userItem = userList[i];
            userMap[userItem.username] = true;
        }
        // console.log("filter infor: ", Object.keys(filteredInfo).filter(x => filteredInfo[x]).length);
        this.columns = [{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Email"/>,
            key: 'email',
            sorter: (a, b) => stringSort(a['username'], b['username']),
            align: 'left',
            filteredValue: filteredInfo.email || null,
            sortOrder: this.state.sortedInfo.columnKey === 'email' && this.state.sortedInfo.order,
            render: (rec) => {
                return (<span>{rec.email || rec.username}</span>);
            },
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            onFilter: (value, record) => (record['username'] || "").toString().toLowerCase().includes(value.toLowerCase())
        },{
            title: <Translation labelName="manage_users_tbl_hdr_name" defaultText="Name"/>,
            key: 'name',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.name || null,
            sortOrder: this.state.sortedInfo.columnKey === 'name' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.firstName + ' ' + a.lastName, b.firstName + ' ' + b.lastName);
            },
            render: (rec) => {
                return (<span>{rec.firstName + ' ' + rec.lastName}</span>);
            },
            onFilter: (value, rec) => {
                return (rec.firstName || "").toString().toLowerCase().includes(value.toLowerCase()) || (rec.lastName || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_cust_company" defaultText="Customer Company"/>,
            key: 'company',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.company || null,
            sortOrder: this.state.sortedInfo.columnKey === 'company' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.company, b.company);
            },
            render: (rec) => {
                return (<span>{rec.company}</span>);
            },
            onFilter: (value, rec) => {
                return (rec.company || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_function" defaultText="Function"/>,
            key: 'function',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.function || null,
            sortOrder: this.state.sortedInfo.columnKey === 'function' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.function, b.function);
            },
            render: (rec) => {
                return (<span>{rec.function}</span>);
            },
            onFilter: (value, rec) => {
                let valueToCheck = (rec.function);
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        }, {
            title: <Translation labelName="manage_users_tbl_hdr_phone" defaultText="Phone"/>,
            key: 'phone',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.phone || null,
            sortOrder: this.state.sortedInfo.columnKey === 'phone' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.phone, b.phone);
            },
            render: (rec) => {
                return (<span>{rec.phone}</span>);
            },
            onFilter: (value, rec) => {
                let valueToCheck = (rec.phone);
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_country" defaultText="Country"/>,
            key: 'country',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.country || null,
            sortOrder: this.state.sortedInfo.columnKey === 'country' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.country, b.country);
            },
            onFilter: (value, rec) => {
                let valueToCheck = (rec.oktaProfile && rec.oktaProfile.company);
                valueToCheck = (rec.azureProfile && rec.azureProfile.company) || valueToCheck;
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            },
            render: (rec) => {
                if (rec.country) {
                    return (<span>{rec.country}</span>);
                }
                return (<span>-</span>);
            }
        }, {
            title: <Translation labelName="manage_users_tbl_hdr_created-on" defaultText="Requested On"/>,
            key: 'createdAt',
            align: 'left',
            sortOrder: this.state.sortedInfo.columnKey === 'createdAt' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                let aTime = new Date(1989, 4, 4).getTime();
                let bTime = new Date(1989, 4, 4).getTime();
                if (a.createdAt) {
                    aTime = a.createdAt;
                }
                if (b.createdAt) {
                    bTime = b.createdAt;
                }
                return dateSort(aTime, bTime);
            },
            render: (rec) => {
                if (rec.createdAt) {
                    let lastLoginToCheck = rec.createdAt;
                    let lastLoginDate = new Date(lastLoginToCheck);
                    let timeDiff = window.currentServerTimestamp - lastLoginDate.getTime();
                    let inMinutes = Math.floor(timeDiff / (1000 * 60));
                    let lastLoginTime = 'Just now';
                    if (inMinutes > 1) {
                        lastLoginTime = `${inMinutes} minutes ago`;
                    }
                    if (inMinutes > 60) {
                        let inHours = Math.floor(inMinutes / 60);
                        lastLoginTime = `${inHours} hours ago`;
                        if (inHours >= 24) {
                            let inDays = Math.floor(inHours / 24);
                            lastLoginTime = `${inDays} days ago`;
                            if (inDays > 10) {
                                let lastLoginYear = lastLoginDate.getFullYear();
                                let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
                                let lastLoginMonth = monthNames[lastLoginDate.getMonth()];
                                let lastLoginDay = lastLoginDate.getDate();
                                lastLoginTime = `${lastLoginMonth} ${lastLoginDay}, ${lastLoginYear}`;
                            }
                        }
                    }
                    return (<span>{ lastLoginTime }</span>);    
                }
                return (<span>-</span>);
            }
        }, {
            title: <Translation labelName="lbl_action" defaultText="Action"/>,
            key: 'action',
            width: 100,
            nocustomfilter: true,
            render: (rec) => {
                if (userMap[rec.email]) {
                    return (<span>Created</span>);
                }
                return (
                    <span>
                        <a className="table-links" href="#" onClick={(e) => this.showAddCompanyModal(e, rec)}><Translation labelName="lbl_create" defaultText="Create" /></a>
                    </span>
                );
            },
        }];
        let ListItem = ({ item }) => (
            <Fragment>
                {item.name || item.Name}
            </Fragment>
        );
        return (
            <Fragment>
                <div className="cmp-manage-messages__header">
                    <BreadcrumbHeading heading={<Translation labelName="title_admin_manage_users" defaultText="Request access List"/>} />
                    <div className="cmp-manage-messages__header-links">
                        
                    </div>
                </div>
                <div className="cmp-manage-messages">
                    <div className="cmp-manage-messages__table-wrapper">
                        <div className="m1-bottom table-control-bar">
                            <div>
                                
                            </div>
                            <div className="table-control-bar__right-section">
                                <span className="right-section__item">Total: { this.state.rows.length }</span>
                            </div>
                        </div>
                        <Table
                            dataSource={this.state.rows}
                            columns={this.columns}
                            rowKey={Math.random}
                            bordered
                            loading={this.state.loading}
                            pagination={false}
                            onChange={this.onTableChange}
                            scroll={{ y: 'calc(100vh - 230px)' }}
                            size="middle" />
                    </div>
                </div>
                {
                    this.state.visibleNewUserModal && (
                        <Modal
                        className="update-role-company"
                        title={ <Translation labelName="title_create_user" defaultText="Create User"/> }
                        visible={this.state.visibleNewUserModal}
                        okText={ <Translation labelName="btn_save" defaultText="Submit"/> }
                        onOk={() => this.createNewUser()}
                        onCancel={this.closeNewUserModal}
                        centered
                        width='750px'>
                            <div>
                                {
                                    this.state.errorMessage &&
                                    (
                                        <div className="error-text">
                                            {this.state.errorMessage}
                                        </div>
                                    )
                                }
                                <div className='new-user-creation-section'>
                                    {
                                        <div>
                                            <InputField
                                                type='text'
                                                label={<Fragment><Translation labelName="lbl_email_address" defaultText="Email address "/>*</Fragment>}
                                                name='emailAddress'
                                                pattern='^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
                                                id='emailAddress'
                                                value={this.state.emailAddress}
                                                onChange={(e) => this.handleChange(e)}
                                            />
                                        </div>
                                    }
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <InputField
                                                type='text'
                                                label={<Fragment><Translation labelName="lbl_firstname" defaultText="Firstname "/>*</Fragment>}
                                                name='firstName'
                                                id='firstName'
                                                value={this.state.firstName}
                                                onChange={(e) => this.handleChange(e)}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <InputField
                                                type='text'
                                                label={<Fragment><Translation labelName="lbl_lastname" defaultText="Lastname "/>*</Fragment>}
                                                name='lastName'
                                                id='lastName'
                                                value={this.state.lastName}
                                                onChange={(e) => this.handleChange(e)}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className='col-md-6'>
                                            <label><Translation labelName="lbl_country_label" defaultText="Country" /></label>
                                            <Combobox
                                                caseSensitive={false}
                                                busy={false}
                                                value={this.state.userCountry}
                                                onChange={(name) => {
                                                    this.setState({
                                                        userCountry: typeof name === 'string' ? name: name.Name,
                                                        filteredCountryNames: this.state.countryNames.filter(item => {
                                                            if (name && typeof name === 'string') {
                                                                return item['Name'].toLowerCase().indexOf(name.toLowerCase()) === 0;
                                                            }
                                                            return true;
                                                        })
                                                    });
                                                }}
                                                data={this.state.filteredCountryNames}
                                                messages={{
                                                    emptyList: <Translation labelName="msg_there_r_no_items_list" defaultText="There are no items in this list"/> ,
                                                }}
                                                textField='Name'
                                                valueField='Name'
                                                itemComponent={ListItem}
                                            />
                                        </div>
                                        <div className='col-md-6'>
                                            <div className="user-preference__row user-company-field">
                                                <label htmlFor="userCompany"><Translation labelName="lbl_user_company" defaultText="Company Name"/></label>
                                                <select className={
                                                        this.state.userCompanyError ? 'has-error' : ''
                                                    } value={this.state.userCompany} name="userCompany" onChange={this.updateUserCompany}>
                                                    <Translation labelName="lbl_none" defaultText="None" isOption />
                                                    {this.state.apiData && (
                                                        this.state.apiData.map((val, i) => {
                                                            return (<option key={i} value={val.company}>{val.company}</option>);
                                                        })
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='new-user-creation-section'>
                                    <div className='row'>
                                        <div className='col-sm-6'>
                                            <div className='user-preference__row'>
                                                <label htmlFor="userFunction"><Translation labelName="lbl_function" defaultText="Function"/></label>
                                                <select className='' value={this.state.userFunction ? this.state.userFunction : ''} name="userFunction" onChange={this.updateUserFunction}>
                                                    <option value="">Select</option>
                                                    <option value="Operations/Quality">Operations/Quality</option>
                                                    <option value="R&amp;D">R&amp;D</option>
                                                    <option value="Procurement">Procurement</option>
                                                    <option value="Business/Sales/Marketing">Business/Sales/Marketing</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className='col-sm-6'>
                                            <InputField
                                                type='text'
                                                label={<Fragment><Translation labelName="lbl_user_phone" defaultText="Phone "/></Fragment>}
                                                name='userPhoneNumber'
                                                id='userPhoneNumber'
                                                value={this.state.userPhoneNumber}
                                                onChange={(e) => this.handleChange(e)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.state.isCreateLoading && <div className="loading-indicator">
                                        <h2 className="loading-indicator-text">
                                            {/* <Icon type="loading" theme="outlined" /> */}
                                            <img alt='loading celanese' src="./images/Celanese_loading.svg" />
                                        <span>Loading</span></h2>
                                    </div>
                                }
                            </div>
                        </Modal>
                    )
                }
            </Fragment>
        );
    }
}

const mapStateToProps = ({ loggedUserState }) => ({
    prefData: loggedUserState.prefData
});

const mapDispatchToProps = dispatch => ({
    getCompaniesData: (data) => dispatch(getCompaniesData(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(RequestAccess);

RequestAccess.propTypes = {
    prefData: PropTypes.object,
    companiesData: PropTypes.any,
    getCompaniesData: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/containers/RequestAccess/index.js